<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  v-if="$ability.can(constants.action.permissionLogin, constants.resource.user) && !isSuperAdmin"
                  v-b-modal.modal-role
                  variant="primary"
                  @click="emailTemplate(addEmailInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_TEMPLATE') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="tableFields"
          :items="templatesData"
        >
          <template #cell(action)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionLogin, constants.resource.user)"
              v-b-modal.modal-role
              icon="EditIcon"
              @click="emailTemplate(data.item)"
            />
            <!-- <feather-icon
              v-if="$ability.can(constants.action.permissionLogin, constants.resource.user)"
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="confirmDeleteText(data.item.id,data.item.name)"
            /> -->
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <email-template-modal
          :template-data="editData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getTemplates"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import EmailTemplateModal from './EmailTemplateModal.vue'
import axiosemail from '../../libs/axiosemail'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    EmailTemplateModal,
  },
  data() {
    return {
      loader: false,
      templatesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addEmailInput: {
        id: 0,
        name: '',
        subject: '',
        content: '',
        type: 'email',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      communication_client_id: '',
      communication_secret: '',
    }
  },
  computed: {
    tableFields() {
      let fields = []
      if (this.user_type === 'Super Admin') {
        fields = [
          { key: 'id', sortable: true },
          { key: 'name', sortable: true, label: i18n.t('DEBTIA_TITLE') },
          { key: 'companyName', sortable: true, label: i18n.t('DEBTIA_COMPANY_NAME') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      } else {
        fields = [
          { key: 'id', sortable: true },
          { key: 'name', sortable: true, label: i18n.t('DEBTIA_TITLE') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      }
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.currentPage = 1
        this.getTemplates()
      },
    },
    currentPage: {
      handler() {
        this.getTemplates()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getTemplates()
      },
    },
  },
  created() {
    this.getCommunicationApiSettings()
    this.actionColumn()
  },
  methods: {
    async getCommunicationApiSettings() {
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.communication_client_id = settings.data.data.client_id
          this.communication_secret = settings.data.data.secret
          this.getTemplates()
        }
      })
    },
    async getTemplates() {
      try {
        // console.log('hey in jeee')
        const headers = {
          clientId: this.communication_client_id,
          secret: this.communication_secret,
        }
        const url = 'get-all-templates-api'
        if (this.user_type === 'Super Admin') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const templates = await axiosemail.get(`/template/${url}?type=email&perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}`, {
          headers,
        })
        this.loader = false
        if (templates.status) {
          this.templatesData = templates.data.data.data
          this.totalPages = templates.data.data.total
          this.from = templates.data.data.from
          this.to = templates.data.data.to
          this.currentPage = templates.data.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    emailTemplate(item) {
      this.modalLoader = true

      this.editData = item
      this.modalLoader = false
    },
    // async deleteTemplate(id) {
    //   this.loader = true
    //   const headers = {
    //     clientId: this.communication_client_id,
    //     secret: this.communication_secret,
    //   }
    //   const templates = await axiosemail.post('/template/delete-template-api',
    //     { templateId: id, type: 'email' }, {
    //       headers,
    //     })
    //   if (templates.status) {
    //     this.getTemplates()
    //   }
    //   this.loader = false
    // },
    confirmDeleteText(id, name) {
      // methodId
      const question = ` '${name}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_WARNING'),
        text: i18n.t('DEBTIA_DELETION_MSG') + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteTemplate(id)
        }
      })
    },
    actionColumn() {
      console.log('hey')
      // if (this.$ability.cannot(constants.action.permissionLogin, constants.resource.user) && this.$ability.cannot(this.constants.action.permissionLogin, this.constants.resource.user)) {
      //   if (this.user_type !== 'Super Admin') {
      //     this.tableFields.splice(2, 1)
      //   } else {
      //     this.tableFields.splice(3, 1)
      //   }
      // }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
